import $ from 'jquery';
import { Maybe, None } from "../misc/option";
import { Switchboard } from "../events";
class InteractionCollection {
    constructor() {
        this._interactions = {};
    }
    get(name) {
        return Maybe(this._interactions[name.toString()]);
    }
    set(name, interaction) {
        this._interactions[name.toString()] = interaction;
    }
    includes(name) {
        return Object.keys(this._interactions).includes(name.toString());
    }
}
export class InteractionManager {
    constructor(map) {
        this.map = map;
        this.active_interaction = None.instance();
        this.interactions = new InteractionCollection();
        this.help_message_box = $('#help-message');
        this.emitter = Switchboard.get_emitter("CONTEXT");
        this.change_emitter = Switchboard.get_emitter("INTERACTION");
        this.receiver = Switchboard.get_receiver("INTERACTION");
        this.receiver.on('i_request', (interaction_name) => { this.active_interaction_name = interaction_name; });
        this.receiver.on('i_req_revert', (interaction_name) => {
            if (this.active_interaction_name === interaction_name)
                this.active_interaction_name = '';
            else
                this.active_interaction_name = interaction_name;
        });
    }
    get expects_geom() {
        return this.active_interaction.isSomeAnd(i => i.geometric);
    }
    get active_interaction_name() {
        return this.active_interaction.map((a) => a.name).unwrapOr('');
    }
    set active_interaction_name(name) {
        if (!name) {
            this.end_interaction();
            return;
        }
        if (this.active_interaction_name === name)
            return;
        if (!this.interactions.includes(name))
            return;
        this.end_interaction();
        this.active_interaction = this.interactions.get(name);
        this.start_interaction();
    }
    start_interaction() {
        this.active_interaction
            .flatmap(i => i.enter_context)
            .map(ec => this.emitter.emit('ctx_request', ec));
        this.active_interaction
            .map(i => { i.init(); return i; })
            .map(i => { for (let i2 of i.interactions)
            this.map.addInteraction(i2); });
        this.setup_exit_behavior();
        this.change_emitter.emit("changed", this.active_interaction_name);
    }
    setup_exit_behavior() {
        $('canvas').one('contextmenu', (e) => {
            e.preventDefault();
            this.help_message_box.addClass('hidden');
            this.active_interaction_name = '';
        });
    }
    end_interaction() {
        this.active_interaction
            .flatmap(i => i.exit_context)
            .map(ec => this.emitter.emit('ctx_request', ec));
        this.active_interaction
            .map(i => { for (let i2 of i.interactions)
            this.map.removeInteraction(i2); return i; })
            .map(i => i.remove());
        this.active_interaction = None.instance();
        this.change_emitter.emit("changed", "");
    }
    add_interactions(...interactions) {
        for (const interaction of interactions) {
            this.interactions.set(interaction.name, interaction);
        }
    }
    pointer_handler(evt) {
        if (evt.dragging)
            return;
        this.active_interaction.map(interaction => this.render_help_message(interaction));
    }
    render_help_message(interaction) {
        if (interaction.help_message.length > 0) {
            this.help_message_box.html(interaction.help_message);
            this.help_message_box.removeClass('hidden');
            return;
        }
        this.help_message_box.addClass('hidden');
    }
}
